'use client';

import { useEffect, useState } from 'react';
import { readTrackSelection, type TrackSelection } from './storage';

export type TrackSelectionState =
  | { status: 'checking' }
  | { status: 'none' }
  | { status: 'selected'; selection: TrackSelection };

/**
 * Resolves the persisted track selection once on mount (static export has no
 * server-known value, so the first render is always `'checking'` for exactly
 * one client-side frame — mirrors the resume-snapshot check in
 * lib/training/sessionSnapshot.ts).
 */
export function useTrackSelection(): TrackSelectionState {
  const [state, setState] = useState<TrackSelectionState>({ status: 'checking' });

  useEffect(() => {
    const selection = readTrackSelection();
    setState(selection ? { status: 'selected', selection } : { status: 'none' });
  }, []);

  return state;
}
